export const formatCurrency = ({
  value,
  currency,
  locale,
}: {
  value: number
  currency: string
  locale?: string | undefined
}) => new Intl.NumberFormat(locale, { style: 'currency', currency }).format(value)

export const formatIban = (iban: string): string =>
  iban.replace(/\s+/g, '').replace(/(.{4})(?=.)/g, '$1 ')

export const formatDate = ({
  value,
  locale,
}: {
  value: string
  locale?: string | undefined
}) =>
  new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(new Date(value))
